import { render, staticRenderFns } from "./sell-price-product.vue?vue&type=template&id=4e3839ee"
import script from "./sell-price-product.vue?vue&type=script&lang=js"
export * from "./sell-price-product.vue?vue&type=script&lang=js"
import style0 from "./sell-price-product.vue?vue&type=style&index=0&id=4e3839ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports